import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(frontend)/registreren/page.client.tsx");
